import cronstrue from 'cronstrue';
import { convertCronToTZ } from './utils';
import { toZonedTime, format as formatTZ } from 'date-fns-tz';
import { Tooltip } from '@mui/material';
import { useGlobalSettings } from '../../app/GlobalSettingProvider';

interface CronValue {
  schedule: string;
}

interface CronTableCellDisplayProps {
  params: {
    value?: CronValue;
  };
  sx?: React.CSSProperties;
}

const CronTableCellDisplay = ({
  params,
  sx = {},
}: CronTableCellDisplayProps) => {
  const { settings } = useGlobalSettings();
  return (
    <Tooltip
      title={
        <div>
          <strong>Raw Cron:</strong> {params?.value?.schedule}
        </div>
      }
    >
      <span style={{ ...sx }}>
        {params?.value?.schedule &&
          cronstrue.toString(
            convertCronToTZ(params.value.schedule, settings.timeZone.current),
            {
              verbose: true,
            },
          ) +
            ` (${formatTZ(toZonedTime(new Date(), settings.timeZone.current), 'zzz', { timeZone: settings.timeZone.current })})`}
      </span>
    </Tooltip>
  );
};

export default CronTableCellDisplay;
